

















































































































































import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import { MAudio } from "@/utils/audio";
@Component({
  watch:{
    selectedValue(){
      this.playState === 'initial';
    }
  }
})
export default class ChooseStyle extends Vue {
  @Prop({ default: [] })
  speakerEmotionCacheVOList: Array<any>;
  @Prop({ default: '' })
  speakerId: string;

  selectedValue: any = this.$props.speakerId||''; //当前选中的风格
  playState = "initial";// initial 初始态，没有播放   playing 正在播放    paused 暂停中
  speakerAudio = null;
  VOICE_CACHE = {};
  created(moduleData: IinjectDatas) {
    this.speakerAudio = MAudio.listen({//试听发音人声音
      playing: () => {
        this.playState = "playing";
      },
      pause: () => {
        this.playState = "paused";
      },
      ended: () => {
        this.playState = "initial";
      }
    });
  }
  mounted(){
    console.log('-选择风格',this.$props.speakerEmotionCacheVOList,this.$props.speakerId)
  }
  @Watch('speakerId', {})
  listenSpeakerId(val) {
    this.selectedValue = val;
  }
  //点击了风格
  onPick(moodSpeaker,idx) {
    if (this.selectedValue === moodSpeaker.speakerId) {
      if (this.playState === 'initial') {
        // 重新开始播放
        this.playAudio(this.selectedValue,idx);
        
      } else if (this.playState === 'paused') {
        // 继续播放
        this.speakerAudio.play();
        this.playState = 'playing'
      } else if (this.playState === 'playing') {
        // 暂停播放
        this.speakerAudio.pause();
        this.playState = 'paused';
      }
      return;
    }

    this.selectedValue = moodSpeaker.speakerId;

    // 重置播放器状态
    // this.resetAudio();//todo

    // 试听
    this.playAudio(this.selectedValue,idx);
    //保存当前发音人(包含了具体风格的发音人)
    this.$emit('onPickStyle',moodSpeaker)
  }
  playAudio(speakerId,idx) {
    let demoUrl = this.speakerEmotionCacheVOList[idx].demoUrl;
    if(demoUrl){
      this.speakerAudio.setSrc(demoUrl);
      this.speakerAudio.play();
      this.playState ='playing';
    }
  }
  stopPlay(){
    this.speakerAudio.setSrc('');
    this.playState ='initial';
  }

    //重置播放器状态
  resetAudio() {
    this.playState = "initial";
    this.speakerAudio && this.speakerAudio.setSrc("");
    this.speakerAudio && this.speakerAudio.stop();
  }
}
